/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Control_TermsInputs */

const en_control_terms = /** @type {(inputs: Control_TermsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Terms`)
};

const zh_control_terms = /** @type {(inputs: Control_TermsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`使用条款`)
};

/**
* | output |
* | --- |
* | "Terms" |
*
* @param {Control_TermsInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const control_terms = /** @type {((inputs?: Control_TermsInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Control_TermsInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_control_terms(inputs)
	return zh_control_terms(inputs)
});
export { control_terms as "control.terms" }